<app-dialog [noCloseIcon]="true">
  <p title>{{ dialogData.title }}</p>
  <p subtitle class="mb-5">{{ dialogData.text }}</p>
  <div class="grid gap-2 w-full px-10 py-6" footer>
    @for (button of buttons; track button.text) {
      <button class="w-full" appButton [color]="button.color" (click)="onSubmit(button.action)">
        {{ button.text }}
      </button>
    }
  </div>
</app-dialog>
